import { render, staticRenderFns } from "./PurchasingMonitoring.vue?vue&type=template&id=2ee32e40&scoped=true"
import script from "./PurchasingMonitoring.vue?vue&type=script&lang=js"
export * from "./PurchasingMonitoring.vue?vue&type=script&lang=js"
import style0 from "./PurchasingMonitoring.vue?vue&type=style&index=0&id=2ee32e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee32e40",
  null
  
)

export default component.exports